import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ChapterNotes from '../components/notes/ChapterNotes';
import { getChapter } from '../data/notes';

export default function ChapterNotesPage() {
  const { subject, chapter } = useParams();
  const data = getChapter(subject, chapter);

  useEffect(() => {
    if (data) {
      const title =
        typeof data.title === 'string'
          ? data.title
          : data.title?.english || data.title?.hindi || chapter;
      document.title = `${title} | JEE/NEET Notes — PrrepX Pathshala`;
    }
  }, [data, chapter]);

  if (!data) {
    return <Navigate to="/study-materials#chapterwise-notes" replace />;
  }

  return <ChapterNotes chapter={data} />;
}
